import PropTypes from 'prop-types';
import Input, { baseFieldClasses } from '../../../form/Input';

const SearchField = ({ onChange, value }) => (
    <Input
        className={baseFieldClasses}
        aria-label={gettext('SEARCH_NOTIFICATIONS')}
        placeholder={gettext('NOTIFICATION_SEARCH_PLACEHOLDER')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
    />
);

SearchField.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
};

export default SearchField;
